import { useState } from "react"
import { SystemSS } from "../../../components/SystemSS"
import { FullScreenModal } from "../../../utility/FullScreenModal"

export const FacilitiesSkills = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setModalContent({ contentType: '', category: '', index: 0 })
        setShowModal(false)
    }
    return (
        <>
            <section className=''>
                <div className='flex justify-center '>
                    <img
                        className=''
                        alt='confine'
                        src={`${process.env.PUBLIC_URL}/images/system/system-skills.webp`}
                    />
                </div>
                <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                    <p>
                        You can learn Skills by clearing the conditions necessary to obtain <span className='text-pborange'>Skills and Abilities</span> and selecting them on the <span className='text-pborange'>“Learn Skill”</span> screen.
                    </p>{' '}<br/>
                    <p>
                        Skills are actions that can be used in combat, such as attacks, healing, or buffs. There are Skills that deal a massive amount of damage to a single enemy, Skills that damage several enemies in a wide range at once, Skills that can heal multiple allies, and more. Carefully choosing your Skills can change the tide of battle! 
                    </p>{' '}<br/>
                    <p>
                        Abilities are tied to a unit’s class or race and have various effects such as increasing their stats, pushing enemies off the map, decreasing damage sustained, strengthening Gadgets, increasing the range of attacks, and much, much more. Take your time and enjoy searching for just the right combination of Abilities to take on battles with ease!
                    </p>{' '}<br/>
                    <p>
                        However, there’s a limit to how many you can learn, so sometimes it may be necessary to forget previously-learned Skills and Abilities. Once a Skill has been learned, it can be forgotten with the <span className='text-pborange'>“Skill Order”</span> command. Skills that have been forgotten can be <span className='text-pborange'>re-learned at any time.</span>
                    </p>{' '}
                    <SystemSS
                        mediaItems={[
                            {
                                modalId: 'skills',
                                index: 1,
                            },
                        ]}
                        handleOpenModal={handleOpenModal}
                    />{' '}
                 
                </div>
            </section>
            <FullScreenModal
                showModal={showModal}
                modalContent={modalContent}
                setModalImage
                handleCloseModal={handleCloseModal}
                setModalContent={setModalContent}
                maxIndex={1}
            />
        </>
    ) 
}
